<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
import Home from "./components/views/Home";

export default {
	name: "App",
	components: {Home},
};
</script>

<style>
video {
	background: #2c2a29;
}

#app {
	background-color: white;
}

#app .navbar-nav li > a {
	color: var(--text-navbar);
}

#app li > a {
	color: var(--text-tabs);
}

:root {
	--color-main: #9CDBD9; /* unused */
	--text-main: #18161b;

	--text-navbar: #2d2926;
	--background-navbar: #EBEBEB;

	--color-validation: #171c8f;
	--text-validation: #FFFFFF;

	--color-export: #171c8f;
	--text-export: #FFFFFF;

	--text-tabs: #2d2926;
	--background-tabs: #FFFFFF;

	--color-border-inputs: #2d2926;

	--text-cancel: #FFFFFF;
	--color-cancel: #FB251A;

	--text-modification: #000000;
	--color-modification: orange;

	--color-main-action: #18161b;
	--text-main-action: #FFFFFF;

	--color-secondary-action: #171c8f;
	--text-secondary-action: #FFFFFF;

	--color-background: #F4F4F4;
	--color-background-2: #CCCCCC;
	--text-background: #000000;

	--color-text-title: #171c8f;
	--color-background-title: #FFFFFF;
	--color-border-link: #171c8f;

	--text-help: #FFFFFF;
	--background-help: #97999b;

	--small-border-radius: 5px;
	--big-border-radius: 10px;
}

#app li > a.dropdown-toggle {
	color: var(--text-navbar);
}

.modal-open {
	overflow: auto !important;
}

#dashboard .nav-tabs {
	border: 0;
}

#dashboard .nav-tabs .nav-link {
	border: 0;
	opacity: 0.5;
	padding:8px 24px;
	color: var(--text-tabs);
}

#dashboard .nav-tabs .nav-link.active {
	opacity: 1;
}

#btn-project-display .btn {
	background: var(--color-background);
	border-color: var(--color-background);
	color: var(--text-background);
	cursor: pointer;
}

#dashboard .pagination .page-item.active .page-link,
#btn-project-display .active {
	background: var(--color-main-action);
	border-color: var(--color-main-action);
	color: var(--text-main-action);
}

#stat_view .card-header {
	border: 0;
	border-radius: 10px;
}

#stat_view .nav-link.active {
	color: var(--background-tabs);
	background: var(--text-tabs);
}

#main_dropdown .dropdown-menu {
	min-width: 243px;
}

#main_dropdown .dropdown-item {
	padding: 5px 14px;
}

#project_step_carrousel .flickity-prev-next-button.previous {
	left:-50px;
}

#project_step_carrousel .flickity-prev-next-button.next {
	right:-50px;
}
</style>
